export default __webpack_public_path__ + "locales/uk-UA/EmptyTrashDialog.json?hash=16890d38a817e07211c32260d99ec437";